module.exports = __webpack_public_path__ + "img/csv.d824d59f.png";